/*
 * Planigo
 * Auteur  : Stéphane Raverdy
 * Société : SCIAD 2026
 */
// REGLE DE GESTION V6 : une seule constante frontend pour la version affichee.
export const APP_VERSION = '7.0.1.1';
